import { render, staticRenderFns } from "./DocketEntryNotificationsEditorDialog.vue?vue&type=template&id=35fedacc&"
import script from "./DocketEntryNotificationsEditorDialog.vue?vue&type=script&lang=js&"
export * from "./DocketEntryNotificationsEditorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports